import React from 'react';
import { motion, type Variants } from 'framer-motion';
const ease = [0.22, 1, 0.36, 1] as const;

/** Staggers its motion children into view */
export const revealContainer: Variants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.05
    }
  }
};

/** Tighter stagger for long grids so the last item never feels late */
export const revealGrid: Variants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.025
    }
  }
};
export const revealItem: Variants = {
  hidden: {
    opacity: 0,
    y: 12
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease,
      staggerChildren: 0.04
    }
  }
};
interface RevealItemProps {
  children: React.ReactNode;
  className?: string;
  /** Stretch the single child to fill a grid cell */
  fill?: boolean;
}
export function RevealItem({
  children,
  className = '',
  fill = false
}: RevealItemProps) {
  return <motion.div variants={revealItem} className={`${fill ? 'flex [&>*]:min-w-0 [&>*]:flex-1' : ''} ${className}`} data-id="element-133" data-mp="1rgsracjy4er6">
      {children}
    </motion.div>;
}